import '@styles/components/appBridgeMaster2023.less';
import '@styles/components/collegeSoftwareSupport.less';
import qrCode from '../assets/images/college/sqm.png'
import AppFooter from '@components/app/appFooter';

const AppCollegeSoftwareSupport = () => {
  return (
    <div className={'container'}>
      <div className="college-title">桥梁大师院校支持</div>
      <div className="title-line"></div>
      <div className="college-content">
        工欲善其事必先利其器，为了让更多的年轻用户了解和使用桥梁大师，自2020年跨世纪推出“毕业支持计划”以来，我们已经为长安大学、云南大学建筑与规划学院、重庆交通大学、广西大学土木工程学院、西北民族大学土木工程学院等院校的同学们免费提供了最新版桥梁大师的软件与技术支持，帮助TA们完成了更加出色的毕业设计和技能学习。
      </div>
      <div className="college-content">
        合格机构的教育工作者可以免费申请桥梁大师软件正版化支持用于教学工作，包括桥梁大师标准版、桥梁大师箱梁版。
      </div>
      <div className="college-item-box box1">
        <div className="item-title">在校生毕业支持申请须知</div>
        <div className="item-li">限在校学生</div>
        <div className="item-li">需填写高校申请软件使用授权书</div>
        <div className="item-li tworows">
          无需购买“加密狗”、“软件锁”等解密插件，只需联网及安装软件，即使更换电脑也可以使用，简单方便、运行顺畅！
        </div>
        <div className="item-li">
          学习链接：
          <a href="https://ke.qq.com/course/package/34199" style={{ color: '#006FFF' }}>
            https://ke.qq.com/course/package/34199
          </a>
        </div>
      </div>
      <div className="college-item-box box2">
        <div className="item-title">院校软件正版化支持申请须知</div>
        <div className="item-li">国内院校均可申请</div>
        <div className="item-li">推动校园软件正版化</div>
        <div className="item-li tworows">
          仅限安装于校内实验室、公共计算机房、多媒体阅览室、办公室等教学、科研、管理和学习场所的计算机上
        </div>
        <div className="item-li">禁止商业用途</div>
      </div>
      <div className="qr-code-box">
        <div className="qrcode">
          <img src={qrCode} alt="qrcode" />
        </div>
        <div className="qr-code-desc">扫描二维码 填写申请表单</div>
      </div>
      <div className="college-title">桥梁大师2022</div>
      <div className="college-content">
        桥梁大师提出了的参数化、批量化桥梁设计思想，采用面向对象、面向桥梁、面向工程的建模技术，软件操作简单、使用方便，受到广大用户一致好评。桥梁大师可用于各种弯、坡、斜等大中小桥设计，可用于整体式路基、分离式路基的双幅桥和单幅桥设计，可完成左右幅路基宽度相同或不同、墩台形式相同或不同、错墩、错台等复杂桥梁设计。软件适用范围广，可满足公路、市政、铁路、港航等不同行业的桥梁设计任务。
      </div>
      <div className="app-display-desc college">
        <div className="intro-bg">
          <div className="content-introduction">
            <div className={'bridgeMaster-list'}>
              <div className={'border'}>
                <span className={'type'}>K（快）</span>
                <span className={'type-introduce'}>更快捷、更轻松的工作</span>
              </div>
              <div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>自动导入路线数据</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>自动套用标准图</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>自动交互设计，属性设计、尺寸驱动</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>拖动修改</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>自动分类汇总、出图、出表</span>
                </div>
              </div>
            </div>
            <div className={'bridgeMaster-list'}>
              <div className={'border'}>
                <span className={'type'}>S（实）</span>
                <span className={'type-introduce'}>解决实实在在的问题</span>
              </div>
              <div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>错墩台等复杂桥型设计</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>变更设计</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>横坡、高程任意调整</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>斜弯桥、变宽桥布梁设计</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>桩位坐标自动计算</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>桥位平面图</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>工程量统计</span>
                </div>
              </div>
            </div>
            <div className={'bridgeMaster-list'}>
              <div className={'border'}>
                <span className={'type'}>J（精）</span>
                <span className={'type-introduce'}>更精细、更精准的设计</span>
              </div>
              <div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>数据一次输入</span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>所见即所得，问题一目了然 </span>
                </div>
                <div>
                  <span className={'list-d'}>●</span>
                  <span className={'list-text'}>甲级设计院校验</span>
                </div>
              </div>
            </div>
            <div className="more-box">
              <div className="more-item">
                <img
                  style={{ width: '19px', margin: '12px 0 10px 0' }}
                  src={require('@images/bridgeMaster/efficiency.png').default}
                  alt=""
                />
                <div className="more-desc">更高的设计效率</div>
              </div>
              <div className="more-item">
                <img
                  style={{ width: '19px', margin: '10px 0 7px 0' }}
                  src={require('@images/bridgeMaster/quality.png').default}
                  alt=""
                />
                <div className="more-desc">更好的设计质量</div>
              </div>
              <div className="more-item">
                <img
                  style={{ width: '23px', margin: '11px 0 8px 0' }}
                  src={require('@images/bridgeMaster/work.png').default}
                  alt=""
                />
                <div className="more-desc">更轻松的设计工作</div>
              </div>
              <div className="more-item">
                <img
                  style={{ width: '23px', margin: '10px 0 8px 0' }}
                  src={require('@images/bridgeMaster/option.png').default}
                  alt=""
                />
                <div className="more-desc">更高水平的设计方案</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AppFooter></AppFooter>
    </div>
  );
};

export default AppCollegeSoftwareSupport;
